import * as React from 'react';

const SvgAlertSetUp = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M5.555 22a3.967 3.967 0 006.89 0zM15 17v-3.571a8 8 0 01-5-7.339A5.971 5.971 0 003 12v5a3 3 0 01-3 3v1h18v-1a3 3 0 01-3-3zm3-17a6 6 0 106 6 6.007 6.007 0 00-6-6zm3 7h-4V2h2v3h2z" />
    </svg>
  );
};

export default SvgAlertSetUp;
